import { render, staticRenderFns } from "./TheSideBar.vue?vue&type=template&id=132170b3"
import script from "./TheSideBar.vue?vue&type=script&lang=js"
export * from "./TheSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports